module.exports = __webpack_public_path__ + "img/20200717_172124.61377b6d.jpg";